<template>
    <div class="page white_bg">

        <div style="height: 46px; line-height: 46px;">
            <header class="pageHeader paddingH16 white_bg">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 11px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px"></div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">
<!--            <div v-if="vipEnjoyData && vipEnjoyData.detail.length">-->
<!--                <div>-->
<!--                    <img class="w100p" height="auto" :src="vipEnjoyData.detail[0].cover" alt=""/>-->
<!--                </div>-->
<!--            </div>-->
            <div v-if="content">
                <article class="article" v-html="content"></article>
            </div>

            <div style="height: 60px;"></div>
        </div><!-- end .body -->

        <div class="fixedBottom bgWhite paddingB24">
            <div class="paddingV8 paddingH16">
                <button class="submitButton" type="button" @click="buy()">申请加入园所精品课尊享</button>
            </div>
        </div>

        <vipRenewalDrawer ref="vipRenewalDrawer"/>
        <vipPayDialog ref="generalPayDialog" :onPaySuccess="onPaySuccess" type="payVip"
              agreeServiceName="师讯VIP会员服务协议"
              agreeServiceUrl="/help/agreement/vip_agreement"/>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

import vipPayDialog from "@comp/drawer/vipPayDialog";
import vipRenewalDrawer from "@comp/drawer/vipRenewalDrawer";

import vipApi from '@/api/vip';
import aboutApi from '@/api/about';
import bizTypeEnum from "@data/bizTypeEnum";
import appHelper from "@util/appHelper";

const config = {
    name : 'courseVip',
    title : '园所精品课尊享',
    description : ''
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : { vipRenewalDrawer ,vipPayDialog  },
    data () {
        return {
            title : config.title,
            description : config.description,
            // VIP 介绍
            vipEnjoyData : null,
            // VIP 套餐数组
            vipInfo : null,

            // VIP 一年套餐信息
            vipPackage : null,

            content: ''
        }
    },
    methods : {
        /**
         * @method  getVipPurchaseYearPackage
         * @param   {String}  type
         * @returns {null|Object}
         */
        getVipPurchaseYearPackage(type = 'super') {

            let vipPurchaseYearList = this.vipPurchasePackages[type];
            for (let i=0; i<vipPurchaseYearList.length; i++)
            {
                if (vipPurchaseYearList[i].timeType === 'year')
                {
                    return vipPurchaseYearList[i];
                }
            }

            return null;
        },

        // 购买会员
        buy() {
            let yearPackage = this.vipPackage;
            this.$refs.generalPayDialog.setProduct({
                id : yearPackage.dbValue,
                title : yearPackage.title,
                price : yearPackage.price,
                bizType : bizTypeEnum.VIP.code
            });
            this.$refs.generalPayDialog.open();
        },

        onPaySuccess : function (result) {
            // let orderId = result.orderId || '';
            appHelper.goToPage('openSuccessForCourseVip');
        },
    },
    mounted() {
        const me = this;
        vipApi.loadVipEnjoyInfo(2, (result) => {
            me.vipEnjoyData = result.data;
        });

        vipApi.loadVipInfo(2, (result) => {
            me.vipInfo = result.data;

            for (let i=0; i<me.vipInfo.length; i++){
                if (me.vipInfo[i].timeType == 'year')
                {
                    me.vipPackage = me.vipInfo[i];
                }
            }
        });

        aboutApi.getResource('COURSE_VIP_DETAIL', (result) => {
            me.content = result;
        });
    }
}
</script>

<style lang="scss" scoped>
.submitButton {
    width: 100%;
    height: 48px;
    border-radius: 24px;
    border: none;
    background-color: rgba(56, 162, 138, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 18px;
}
</style>
